<mat-select
  [formControl]="selectedTz"
  (openedChange)="onOpenedChange($event)"
  [panelWidth]="360"
  [disabled]="disabled"
  [hideSingleSelectionIndicator]="true">
  
  <mat-select-trigger>
    <span class="name">{{ selectedTz.value }}</span>
  </mat-select-trigger>

  <!-- Search Box -->
  <div class="search-timezone">
    <mat-form-field style="width: 100%">
      <input
        #tzSearch
        type="text"
        matInput
        placeholder="Search timezone"
        [formControl]="timezoneSearchCtrl" />
    </mat-form-field>
  </div>

  <!-- Timezone Options -->
  <mat-option
    class="timezone-option"
    *ngFor="let tz of timezones$ | async"
    [value]="tz.name"
    (click)="timezoneSearchCtrl.setValue('')">
    <span class="name">{{ tz.name }}</span>
    <span class="utc">{{ tz.offsetFormatted }}</span>
  </mat-option>
</mat-select>
